export const SHOW_LOCALITY_SECTOR_CODE = 70000;
export const LOCALITY_SECTORS = ['1', '2', '3', '4', '5', '6'];